import { isProductionBuild } from '@/utils/environment'

export const LEGACY_RESERVATIONS_BOOKINGS_PATH =
  '/dashboard/building-dashboard/reservations/bookings/reservations-list'
export const NEW_RESERVATIONS_BOOKINGS_PATH = '/reservations/bookings'

// TODO: remove the production gate (and the legacy path) once the new Reservations pages launch.
export const RESERVATIONS_BOOKINGS_PATH = isProductionBuild
  ? LEGACY_RESERVATIONS_BOOKINGS_PATH
  : NEW_RESERVATIONS_BOOKINGS_PATH
